import type { InsufficientCreditsError } from "api";
import { Modal } from "components/ui/Modal";
import { outOfCreditsText } from "./credits.model";

type OutOfCreditsModalProps = {
  denial: InsufficientCreditsError;
  onBuy: () => void;
  onClose: () => void;
};

/**
 * The 402 `insufficient_credits` answer, in place of the design's
 * `#planneed-modal`: what the action needs, what is left, and the way to buy more.
 */
export const OutOfCreditsModal = ({ denial, onBuy, onClose }: OutOfCreditsModalProps) => (
  <Modal
    title="Not enough QCredits"
    onClose={onClose}
    actions={
      <>
        <button
          type="button"
          className="pcbtn pcbtn--main"
          onClick={() => {
            onClose();
            onBuy();
          }}
        >
          Buy QCredits
        </button>
        <button type="button" className="pcbtn" onClick={onClose}>
          Not now
        </button>
      </>
    }
  >
    <p className="pcmodal__t">{outOfCreditsText(denial)}</p>
  </Modal>
);
